
import { FileText, Camera, Lightbulb, TrendingUp, Users, CheckCircle } from 'lucide-react';

export const getValoGuideStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "ValoGuide - Guide de Valorisation des Déchets",
  "description": "Guide complet de valorisation des déchets avec conseils pratiques, galerie photos d'actualités et innovations du secteur environnemental.",
  "url": "https://www.groupefabre-environnement.fr/valoguide",
  "mainEntity": {
    "@type": "Article",
    "headline": "Guide de Valorisation des Déchets",
    "description": "Ressources et conseils pour une gestion optimale des déchets avec galerie photos d'actualités environnementales",
    "author": {
      "@type": "Organization",
      "name": "Groupe Fabre Environnement"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Groupe Fabre Environnement",
      "logo": {
        "@type": "ImageObject",
        "url": "https://lovable.dev/opengraph-image-p98pqg.png"
      }
    },
    "image": {
      "@type": "ImageObject",
      "url": "https://lovable.dev/opengraph-image-p98pqg.png"
    }
  },
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Accueil",
        "item": "https://www.groupefabre-environnement.fr"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "ValoGuide",
        "item": "https://www.groupefabre-environnement.fr/valoguide"
      }
    ]
  },
  "about": [
    {
      "@type": "Thing",
      "name": "Valorisation des déchets"
    },
    {
      "@type": "Thing", 
      "name": "Recyclage"
    },
    {
      "@type": "Thing",
      "name": "Gestion environnementale"
    }
  ]
});

export const getBreadcrumbItems = () => [
  { label: "Accueil", href: "/" },
  { label: "ValoGuide", href: "/valoguide", current: true }
];

export const getContentBlocks = () => [
  {
    type: 'text' as const,
    title: "Qu'est-ce que ValoGuide ?",
    content: "ValoGuide est votre guide complet pour la valorisation des déchets. Découvrez nos conseils d'experts, actualités du secteur et innovations pour une gestion environnementale responsable et optimisée.",
    variant: 'highlighted' as const
  },
  {
    type: 'benefits' as const,
    title: "Nos domaines d'expertise",
    benefits: [
      {
        title: "Conseils pratiques",
        description: "Guides détaillés pour optimiser le tri et la valorisation de vos déchets",
        icon: Lightbulb
      },
      {
        title: "Actualités secteur",
        description: "Dernières innovations et évolutions réglementaires du recyclage",
        icon: TrendingUp
      },
      {
        title: "Galerie photos",
        description: "Découvrez nos sites et installations en images",
        icon: Camera
      }
    ],
    variant: 'success' as const
  },
  {
    type: 'list' as const,
    title: "Nos conseils pour une valorisation optimale",
    items: [
      "Identification et tri sélectif des différents types de déchets",
      "Valorisation spécialisée des métaux ferreux et non ferreux",
      "Gestion des DEEE (Déchets d'Équipements Électriques et Électroniques)",
      "Recyclage des papiers, cartons et emballages",
      "Optimisation des coûts de gestion des déchets",
      "Mise en conformité avec la réglementation environnementale",
      "Solutions de collecte et transport adaptées",
      "Traçabilité complète des flux de déchets"
    ]
  }
];

export { FileText, Users, CheckCircle };
